import { PRE_SALE_DROPDOWN, CREATE_PRE_SALE_SUPPLY,GET_BLOCKED_DATA,UPDATE_BLOCKED_USER} from "./type";

const initalState = {
  dropDownList: [],
  submitSuccess: {},
  blockedUserData:[],
  updateBlockedUser: {},
};

const getDropDownReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRE_SALE_DROPDOWN:
      return {
        ...state,
        dropDownList: payload,
      };

    case CREATE_PRE_SALE_SUPPLY:
      return {
        ...state,
        submitSuccess: payload,
      };

    case GET_BLOCKED_DATA:
      return {
        ...state,
        blockedUserData: payload,
      };

    case UPDATE_BLOCKED_USER:
      return {
        ...state,
        updateBlockedUser: payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default getDropDownReducer;
